var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 597.04 150.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.76,23.19c0,11.06-6.75,21.82-22.01,21.82h-13.89v23.58h-13.6V1.17h27.49c15.26,0,22.01,10.96,22.01,22.01ZM309.07,23.19c0-4.89-2.45-9.98-8.81-9.98h-13.4v19.86h13.21c6.56,0,9-5.09,9-9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.56,34.93c0-19.18,15.07-34.93,34.24-34.93s34.34,15.75,34.34,34.93-15.26,34.83-34.34,34.83-34.24-15.75-34.24-34.83ZM382.44,34.93c0-12.13-8.61-22.11-20.64-22.11s-20.64,9.98-20.64,22.11,8.51,22.01,20.64,22.01,20.64-9.88,20.64-22.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.48,1.17l-22.89,67.41h-10.86l-9.78-36.59-9.59,36.59h-10.86L397.7,1.17h14.68l13.7,43.93,9.49-34.44h11.06l9.29,34.44,13.79-43.93h14.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.67,56.55v12.03h-43.15V1.17h42.27v12.03h-28.67v16.05h25.14v12.23h-25.14v15.07h29.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M563.93,44.42h-4.6v24.17h-13.6V1.17h26.91c15.46,0,22.11,10.96,22.11,22.01,0,9.59-6.75,18.98-16.24,20.64l17.41,24.75h-15.95l-16.05-24.17ZM559.33,33.46h10.86c7.63,0,10.86-4.6,10.86-9.98s-3.42-10.27-9.78-10.27h-11.94v20.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.13,9.97L0,25.1h122.32L28.49,118.93V49.78L.11,37.27v111.23h21.83c8.65,0,16.95-3.44,23.06-9.55L175.18,8.77c3.08-3.08.9-8.35-3.46-8.35H38.19C29.54.41,21.25,3.85,15.13,9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.32,138.95l15.13-15.13h-122.32L215.97,29.99v69.15s28.38,12.5,28.38,12.5V.41h-21.83c-8.65,0-16.95,3.44-23.06,9.55L69.28,140.15c-3.08,3.08-.9,8.35,3.46,8.35h133.52c8.65,0,16.95-3.44,23.06-9.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.93,115.58c0-19.18,15.07-34.93,34.44-34.93,10.17,0,19.08,4.21,24.95,10.76l-9.88,8.51c-3.82-4.11-9.2-6.65-15.07-6.65-11.74,0-20.84,10.27-20.84,22.31s8.9,22.6,21.23,22.6c8.81,0,17.51-5.28,17.51-13.11h-19.08v-11.06h33.95c0,24.95-13.79,36.4-32.09,36.4-20.35,0-35.12-15.75-35.12-34.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.44,125.07h-4.6v24.17h-13.6v-67.41h26.9c15.46,0,22.11,10.96,22.11,22.01,0,9.59-6.75,18.98-16.24,20.64l17.41,24.75h-15.95l-16.05-24.17ZM361.84,114.11h10.86c7.63,0,10.86-4.6,10.86-9.98s-3.42-10.27-9.78-10.27h-11.94v20.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.01,115.58c0-19.18,15.07-34.93,34.24-34.93s34.34,15.75,34.34,34.93-15.26,34.83-34.34,34.83-34.24-15.75-34.24-34.83ZM458.9,115.58c0-12.13-8.61-22.11-20.64-22.11s-20.64,9.98-20.64,22.11,8.51,22.01,20.64,22.01,20.64-9.88,20.64-22.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.28,125.46v-43.64h13.6v42.75c0,9.2,5.87,12.91,12.13,12.91s12.23-3.72,12.23-12.91v-42.75h13.6v43.64c0,15.46-12.03,24.95-25.83,24.95s-25.73-9.49-25.73-24.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.04,103.84c0,11.06-6.75,21.82-22.01,21.82h-13.89v23.58h-13.6v-67.41h27.49c15.26,0,22.01,10.96,22.01,22.01ZM583.35,103.84c0-4.89-2.45-9.98-8.81-9.98h-13.4v19.86h13.21c6.56,0,9-5.09,9-9.88Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodLogo);
export default __webpack_public_path__ + "static/media/COD Logo.f403796b0494e6730a0527fe3139803a.svg";
export { ForwardRef as ReactComponent };